<ng-template #modalconfirmacion let-modal>
    <mat-dialog-content>
        <div class="modal-header text-center">
            <div class="headerm">
                <mat-icon aria-hidden="false" aria-label="Example home icon">report</mat-icon>
                <h5 class="modal-title">
                    <div [innerHTML]="TituloMostrar"></div>
                </h5>
            </div>

            <button id="confirmacion_cerrar" type="button" class="close" aria-label="Close" [mat-dialog-close]="false">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body text-center">
            <div class="row">
                <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
                <div [formGroup]="form" class="col-md-12" autocomplete="off">
                    <div class="row">
                        <div class="col-md-12 col-lg-12 col-12">
                            <mat-form-field appearance="fill">
                                <mat-label>Producto (*)</mat-label>
                                <mat-select formControlName="aliado" [disabled]="!this._HabilitarAliado">
                                    <mat-option [value]="item.idAliado" *ngFor="let item of this._ListaAliados">{{item.aliado}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('aliado').hasError('required')">El Aliado es un campo requerido</mat-error>
                                <mat-error *ngIf="form.get('aliado').hasError('min')">El Aliado es un campo requerido</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-12 col-lg-12 col-12" *ngIf="this._MostrarCanal">
                            <mat-form-field appearance="fill">
                                <mat-label>Canal (*)</mat-label>
                                <mat-select formControlName="canal">
                                    <mat-option [value]="item.idCanal" *ngFor="let item of this._ListaCanales">{{item.canal}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('canal').hasError('required')">El Canal es un campo requerido</mat-error>
                                <mat-error *ngIf="form.get('canal').hasError('min')">El Canal es un campo requerido</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button id="confirmacion_no" type="button" class="btn btn-primary" [disabled]="this.mostrarCargando" (click)="NoSeleccionoInformacion()">{{TextoNoMostrar}}</button>
        <button id="confirmacion_si" type="button" class="btn btn-danger" [disabled]="!this.form.valid || this.mostrarCargando" (click)="SeleccionoInformacion()">{{TextoSiMostrar}}</button>
    </mat-dialog-actions>
</ng-template>